const formatFileInfo = (key, value) => {
    const title = key.split(' - ')[1].split('.')
    switch (value) {
      case 'name': return title[0]
      case 'type': return title[1]
      default: break
    }
}

export { formatFileInfo }